module.exports = __webpack_public_path__ + "static/media/Primate-House7.bdc4e84e.jpg";